<template>
  <div>
    <img class="doc-icon" :src="returnFileType()" />
  </div>
</template>

<script>
export default {
    props:{
        "file_name" : String
    },
    methods:{

        returnFileType() {
            console.log("inside regular icon component", this.file_name)
            var idx_ext = this.file_name.split(".").length - 1;
            var extension = this.file_name.split(".")[idx_ext].toLowerCase();
            var return_val = require("@/assets/img/doc_icon.svg");
            switch (extension) {
              case "docx":
                    return_val = require("@/assets/img/doc_icon.svg");
                    break;
                case "dotx":
                    return_val = require("@/assets/img/doc_icon.svg");
                    break;
                case "dotm":
                    return_val = require("@/assets/img/doc_icon.svg");
                    break;
                case "pptx":
                    return_val = require("@/assets/img/ppt-icon.png");
                    break;
                case "ppt":
                    return_val = require("@/assets/img/ppt-icon.png");
                    break;
                case "doc":
                    return_val = require("@/assets/img/doc_icon.svg");
                    break;
                case "pdf":
                    return_val = require("@/assets/img/pdf_icon.svg");
                    break;
                case "csv":
                    return_val = require("@/assets/img/xls_icon.svg");
                    break;
                case "xlsx":
                    return_val = require("@/assets/img/xls_icon.svg");
                    break;
                case "jpg":
                    return_val = require("@/assets/img/jpg_icon.svg");
                    break;
                case "jpeg":
                    return_val = require("@/assets/img/jpg_icon.svg");
                    break;
                case "png":
                    return_val = require("@/assets/img/png_icon.svg");
                    break;
                case "folder":
                    return_val = require("@/assets/img/folder_yellow.svg");
                    break;
                default:
                    return_val = require("@/assets/img/dat_icon.svg");
                    break;
            }
            return return_val;
        },
    }
}
</script>

<style>

</style>